import { Component } from '@angular/core';

@Component({
    selector: 'pdf-match-diacritics',
    templateUrl: './pdf-match-diacritics.component.html',
    styleUrls: [],
    standalone: false
})
export class PdfMatchDiacriticsComponent {}
